const MAP_VERSION = '5.4.10';
const domain = import.meta.env.VITE_CUSTOM_MAP_DOMAIN || '';
export const WEBVIEW_MAP_URL = `${domain}/watcherr-map/${MAP_VERSION}/index.html`;

export enum MapEvent {
  MapInitialised,
  MarkerPressed,
  InsertMarker,
  CancelInsertMarker,
  MapIsFullscreen,
  GoBack,
  UpdateMarkers,
  FloorLoaded,
  UpdateParams,
  MapClick,
  Log,
  GoToCenter,
  GeoFenceSelectableUpdate,
  GeoFenceUpdate,
  PlaneUpdated,
  MarkersUpdated,
  ShowRooms,
  CalculatedRoomMarkersUpdate,
  ZoneDrawZonesChanged,
  ZoneDrawZoneClick,
  ZoneDrawingCreatedUpdated,
  ZoneDrawCreateDrawingClick,
  AppInitialised,
  PlaneSelected,
  Error,
  SetOutdoorPolygon,
}
